import React, { Component } from 'react';
import Datas from '../../data/faq/faq.json';
import { Accordion, Card, Button, Row, Col, Tab, Nav,Table,Container } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/projects.js';
import axios from 'axios';
import imageLink from './styles/KTOLOGO.png';

import {
  FaArrowUp,
  FaArrowDown,
  FaFlag,
  FaBriefcase,
  FaUser,
  FaBuilding,
  FaMoneyBill,
} from "react-icons/fa";

const url =
  "https://kto.stechomeyazilim.info/apiweb2/RestController.php?view=getProject";

class Faq extends Component {
        constructor() {
        super();
        this.state = {
ArrayProject: [],
ArrayProjectCategory: [],
      buttonState: [{id:""}],
      projectsArray:[],
      selectedValue: {},

        };
    }
    
    async componentDidMount() {

        await this._starting();

}
passId(id){
    id=this.state.ID;
  }
_starting = async () => {

          await  this.getProjects();

    
}

  getProjects = async () => {
    try {
      axios.get(url).then((res) => {
        this.setState(
          {
            projectsArray: res.data.cikti,
          },
          () => {}
        );
      });
    } catch (error) {
      console.log("error" + error);
    }
  };

_getProjectsCategory = async () => {
        try {      
    

await axios.get('https://kto.stechomeyazilim.info:5000/projectsCategory/select/')
      .then(res => {

  this.setState({
                ArrayProjectCategory : res.data.cikti

          }, () => {

          })

      })
  
              

        } catch (error) {
          
          console.log("error" + error)
        }
      }


_toggleItem = async (itemId,category,order) => {

    const { selectedValue } = this.state;
    const isSelected = selectedValue[itemId];
    selectedValue[itemId] = !isSelected;


await axios.get(`https://kto.stechomeyazilim.info:5000/projects/select/${category}/${order}/`)
      .then(res => {

  this.setState({
                projectsArray : res.data.cikti

          }, () => {

          })

      })



if (selectedValue[2] == true) {
    
}

if (selectedValue[3] == true) {
    
}

if (selectedValue[4] == true) {
    
}

    this.setState({
       selectedValue: {...selectedValue},
      }, () => {


      })

  }

    render() {
         const { selectedValue } = this.state;

        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper faq-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Projelerimiz" />

                    {/* Faq Area */}
                    <section className="faq-area">
                        <Container>
                            <Row>
                                <Col md="12">
                                 
          <Table bordered style={{ 

  backgroundImage: `url(${imageLink})` 
}} >
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>
                  <FaBriefcase /> Proje Adı
                  <a
                    onClick={() =>
                     this._toggleItem("0", "Projects_Name", selectedValue["0"] == true ? "azalan" : "artan" )
                    }
                  >
                    {selectedValue["0"]? <FaArrowUp /> : <FaArrowDown />}
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  <FaBriefcase /> Durumu
                   <a
                    onClick={() =>
                     this._toggleItem("1", "ProjectsStatus", selectedValue["1"] == true ? "azalan" : "artan" )
                    }
                  >
                    {selectedValue["1"]? <FaArrowUp /> : <FaArrowDown />}
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  <FaFlag /> Ulusal/Uluslaraası 
                  <a
                    onClick={() =>
                     this._toggleItem("2", "National_Check", selectedValue["2"] == true ? "azalan" : "artan" )
                    }
                  >
                    {selectedValue["2"]? <FaArrowUp /> : <FaArrowDown />}
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  <FaUser /> Proje Koordinatörü
                 <a
                    onClick={() =>
                     this._toggleItem("3", "Project_Coordinator", selectedValue["3"] == true ? "azalan" : "artan" )
                    }
                  >
                    {selectedValue["3"]? <FaArrowUp /> : <FaArrowDown />}
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  <FaBuilding /> Proje Yürüten Kuruluş 
                   <a
                    onClick={() =>
                     this._toggleItem("4", "Project_Institution", selectedValue["4"] == true ? "azalan" : "artan" )
                    }
                  >
                    {selectedValue["4"]? <FaArrowUp /> : <FaArrowDown />}
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  Proje Fon Sağlayan kuruluşlar 
                 <a
                    onClick={() =>
                     this._toggleItem("5", "Project_Budget", selectedValue["5"] == true ? "azalan" : "artan" )
                    }
                  >
                    {selectedValue["5"]? <FaArrowUp /> : <FaArrowDown />}
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  <FaMoneyBill /> Proje Bütçesi 
                 <a
                    onClick={() =>
                     this._toggleItem("6", "Project_Budget", selectedValue["6"] == true ? "azalan" : "artan" )
                    }
                  >
                    {selectedValue["6"]? <FaArrowUp /> : <FaArrowDown />}
                  </a>
                </th>
              </tr>
            </thead>
            {this.state.projectsArray.map((item, i) => (
              <tr key={item.ID}>
                                <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
{item.Projects_Name}</th>
               { item.ProjectsStatus == 0 ?                 <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
Tamamlandı</th> :
                               <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
Devam Ediyor</th>}
                
                <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
                  <a onClick={() => this.passId(item.ID)}></a>
                  {item.National_Check}
                </th>
                <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
                  {item.Project_Coordinator}
                </th>
                <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
                  {item.Project_Institution}
                </th>
                <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
                  {item.Project_Budget_Institution}
                </th>
                <th style={{   fontFamily: "Times New Roman", textAlign: "center" }}>
                {item.Project_Budget}</th>
              </tr>
            ))}
          </Table>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default Faq